export enum ItineraryPreferenceTab {
  TRAVELERS = 'travelers',
  PLACES = 'places',
  MEALS = 'meals',
  TIMING = 'timing',
  TRANSIT = 'transit',
  DAYPLAN = 'dayplan',
  BUDGET = 'budget',
}

export const tabItems = [
  // {
  //   title: 'Travelers',
  //   name: ItineraryPreferenceTab.TRAVELERS,
  //   count: 0,
  // },
  {
    title: 'Finding Places',
    name: ItineraryPreferenceTab.PLACES,
    count: 0,
  },
  {
    title: 'Planning Meals',
    name: ItineraryPreferenceTab.MEALS,
    count: 0,
  },
  {
    title: 'Pacing & Timing',
    name: ItineraryPreferenceTab.TIMING,
    count: 0,
  },
  {
    title: 'Transit Modes',
    name: ItineraryPreferenceTab.TRANSIT,
    count: 0,
  },
  {
    title: 'Trip Anatomy',
    name: ItineraryPreferenceTab.DAYPLAN,
    count: 0,
  },
  {
    title: 'Budget & Points',
    name: ItineraryPreferenceTab.BUDGET,
    count: 0,
  },
];
